import React, { memo } from "react";
import SwitchPracticesModal from "./SwitchPracticesForm";
import { Modal as ReactstrapModal, ModalBody } from "reactstrap";

const SwitchPracticeModal = ({ isOpen, toggle }) => {
  return (
    <ReactstrapModal
      centered={true}
      backdrop={"static"}
      isOpen={isOpen}
      size={"md"}
    >
      <div className="pt-3 pb-1 grayBg rounded-3">
        <ModalBody>
          <SwitchPracticesModal toggle={toggle} />
        </ModalBody>
      </div>
    </ReactstrapModal>
  );
};

export default memo(SwitchPracticeModal);
